import { PlayerData } from "@/lib/types/player";
import { ELocalStorageKeys } from "../storage/enums";
import { webStorageUtil } from "../storage/webStorageUtil";

class PlayerService {
    getPlayerData(): PlayerData | null {
        return webStorageUtil.get(ELocalStorageKeys.PLAYER_DATA);
    }

    setPlayerData(playerData: PlayerData) {
        webStorageUtil.set(ELocalStorageKeys.PLAYER_DATA, playerData);
    }
}

export default new PlayerService();